import { makeStyles } from 'tss-react/mui'


const useStyles = makeStyles()((theme) => ({
    container: {
        display: 'flex',
        alignItems: 'center',
        color: theme.palette.text.secondary,
        padding: 0,
        width: '100%'
    },
    value: {
        lineHeight: '20px',
        fontSize: '14px'
    },
    compact: {
        width: '40px'
    }
}))

export default useStyles